module.exports = __webpack_public_path__ + "static/media/oasis.d602844b.png";